import React from 'react';
import DataCenterAndLocationsPage from '../DataCenterAndLocationsPage';
import PageSEO from '../../../../../Components/SEO/PageSEO';

const UtahDataCenterAndLocationsPage = () => {
  // Define structured data for the Utah Data Center
  const utahDataCenterSchema = {
    "@context": "https://schema.org",
    "@type": "DataCenter",
    "name": "WebNX Ogden Data Center",
    "description": "Enterprise-grade data center in Ogden, Utah offering high-performance colocation services with direct carrier connections and optimized routing for Western US and Asia-Pacific traffic.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Ogden",
      "addressRegion": "UT",
      "addressCountry": "US"
    },
    "offers": {
      "@type": "AggregateOffer",
      "offers": [
        {
          "@type": "Offer",
          "name": "Colocation Services",
          "description": "Secure, reliable colocation with flexible rack space and power options"
        },
        {
          "@type": "Offer",
          "name": "Dedicated Servers",
          "description": "High-performance dedicated servers with instant provisioning"
        },
        {
          "@type": "Offer",
          "name": "Network Services",
          "description": "High-speed connectivity with multiple carrier options and DDoS protection"
        }
      ]
    },
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "24/7 Security",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Redundant Power",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Climate Control",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Fire Suppression",
        "value": true
      }
    ],
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.2230",
      "longitude": "-111.9738"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    }
  };

  return (
    <>
      <PageSEO
        title="Ogden, Utah Data Center | WebNX Colocation & Dedicated Servers"
        description="Enterprise-grade data center in Ogden, Utah offering high-performance colocation services, dedicated servers, and optimized network connectivity. Featuring 24/7 security, redundant power, and direct carrier connections."
        keywords="Ogden data center, Utah colocation, WebNX Utah, dedicated servers Utah, data center Utah, colocation services, enterprise hosting, server hosting, network connectivity, carrier-neutral facility"
        path="/datacenter-locations-and-networks/utah"
        image="https://webnx.com/assets/utah-datacenter.jpg"
        schema={utahDataCenterSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/WebNX/",
          linkedin: "https://www.linkedin.com/company/webnx/"
        }}
      />
      <DataCenterAndLocationsPage location="utah" />
    </>
  );
};

export default UtahDataCenterAndLocationsPage